export enum TabRoutes {
  Quote = "/quote",
  Subjectivity = "/subjectivity",
  Document = "/document"
}
